<template>
  <el-dialog :visible.sync="visible" title="流转记录" :close-on-click-modal="false"
             :close-on-press-escape="false" width="80%">
    <SweetTable ref="table" url="/trade/factorystorelog/page" api-version="v2" :height="500" :query-form="queryForm"
                :summaries-column="['count']" :before-table-binding="beforeTableBinding" :auto-load="false">
      <el-table-column
          prop="orderCode"
          label="外销合同编号"
          header-align="center"
          align="center" width="160"
          :show-overflow-tooltip="true"
      >
        <template #default="{row}">
          <span>{{ row.orderCode }}</span>
          <el-tag type="success" style="margin-left: 6px;" size="mini"
                  v-if="row.orderStatus===$const.orderStatus.COMPLETED">已结束
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
          prop="batchCode"
          label="发货批次号"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
          width="110" :show-tooltip-when-overflow="true"
      ></el-table-column>
      <el-table-column
          prop="senderName"
          label="发货方"
          header-align="center"
          align="center"
          width="160"
          :show-overflow-tooltip="true"
          :formatter="$c.companyNameFormatter"
      ></el-table-column>
      <el-table-column
          prop="receiverName"
          label="收货方"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
          width="160"
          :formatter="$c.companyNameFormatter"
      ></el-table-column>
      <el-table-column
          prop=""
          label="品番/物料信息"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      >
        <template #default="{row}">
          <ProductRowCard :product="row.product"></ProductRowCard>
        </template>
      </el-table-column>
      <el-table-column
          prop="sendCount"
          label="发货数"
          header-align="center"
          align="center"
          width="100"
      >
      </el-table-column>
      <el-table-column
          label="收货数"
          header-align="center"
          align="center"
          prop="count"
          width="100"
      >
      </el-table-column>
      <el-table-column
          label="操作原因"
          header-align="center"
          width="80"
          align="center"
          prop="reason"
      ></el-table-column>
      <el-table-column
          label="记录时间"
          header-align="center"
          align="left"
          width="220"
      >
        <template #default="{row}">
          <div>发货：{{ row.operateTime }}</div>
          <div>收货：{{ row.status === 10 ? '未确认收货' : row.receiveOptTime }}</div>
          <div>制单：{{ row.createDate }}</div>
        </template>
      </el-table-column>
      <el-table-column
          label="操作人"
          header-align="center"
          width="140"
      >
        <template #default="{row}">
          <div>发货：{{ row.creatorName }}</div>
          <div>收货：{{ row.status === 10 ? '未确认收货' : row.receiveOptManName }}</div>
          <div>制单：{{ row.creatorName }}</div>
        </template>
      </el-table-column>
    </SweetTable>
  </el-dialog>
</template>

<script>
/**
 * 库存流转记录弹窗(库存调配-转出/转入,退货-来源去向)
 */
import SweetTable from '@/mixins/SweetTable'
import BigNumber from 'bignumber.js'
import ProductRowCard from '@/components/ProductRowCard.vue'

export default {
  name: 'material-receive-list',
  components: { ProductRowCard },
  mixins: [SweetTable],
  props: {
    queryForm: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      visible: false,
    }
  },
  computed: {
  },
  methods: {
    beforeTableBinding (dataList) {
      dataList.forEach(row => {
        row.count = new BigNumber(row.count).multipliedBy(row.type)
      })
    },
    init (factoryId, materialId, orderId) {
      this.queryForm = {
        storageId: factoryId,
        productId: materialId,
        agreementId: orderId
      }
      this.reload()
      this.visible = true
    }
  }
}
</script>

<style scoped>

</style>
